import { SelectorCategory } from '@nx-ng/types';

export const iconHeaderMap: {
  [S in SelectorCategory]: { icon: string; label: string };
} = {
  customer: {
    icon: 'fa-user',
    label: 'label_customer_type',
  },
  method: {
    icon: 'fa-bus',
    label: 'label_travel_method',
  },
  time: {
    icon: 'fa-clock-o',
    label: 'label_travel_time',
  },
  zone: {
    icon: 'fa-map',
    label: 'label_zone',
  },
};
